import React, { createContext, useState, useContext } from 'react';
import translations from './translations';

export const LANGUAGES = [
  { code: 'uk', label: 'UA', name: 'Українська', flag: '🇺🇦' },
  { code: 'en', label: 'EN', name: 'English',    flag: '🇬🇧' },
  { code: 'de', label: 'DE', name: 'Deutsch',    flag: '🇩🇪' },
  { code: 'es', label: 'ES', name: 'Español',    flag: '🇪🇸' },
  { code: 'fr', label: 'FR', name: 'Français',   flag: '🇫🇷' },
];

const DEFAULT_LANG = 'uk';

export const LangContext = createContext({
  lang: DEFAULT_LANG,
  t: translations[DEFAULT_LANG],
  setLang: () => {},
});

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('lang');
    return saved && translations[saved] ? saved : DEFAULT_LANG;
  });

  const handleSetLang = (code) => {
    if (translations[code]) {
      localStorage.setItem('lang', code);
      setLang(code);
    }
  };

  return (
    <LangContext.Provider value={{ lang, t: translations[lang], setLang: handleSetLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
